import {createActions} from 'redux-actions';

const {message} = createActions({
    MESSAGE: {
        SHOW: undefined,
        HIDE: undefined,
    }
});

export default message;